import { DialectSdk } from '../context/DialectContext/Sdk';
const useDialectSdk = (unsafe) => {
    const { sdk } = DialectSdk.useContainer();
    if (unsafe) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return sdk;
    }
    if (!sdk) {
        throw new Error('sdk not initialized');
    }
    return sdk;
};
export default useDialectSdk;
//# sourceMappingURL=useDialectSdk.js.map